import { Directive, OnInit, OnDestroy, Input, Injectable, Inject, Optional, forwardRef } from '@angular/core';
import { DataBindingDirective, GridComponent } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';
import {  CustomerGroupDataService } from '../data-services';
import { ODataBindingDirective } from './core/o-data-binding-directive';
import { ODataEntitySetResource } from 'angular-odata';

@Injectable()
@Directive({
    selector: '[customerGroupBinding]'
})
export class CustomerGroupBindingDirective extends ODataBindingDirective {

    @Input('customerGroupBinding') query:  ODataEntitySetResource<any>;
    
    constructor(  @Inject(forwardRef(() => CustomerGroupDataService)) dataService: CustomerGroupDataService, @Inject(forwardRef(() => GridComponent))  grid: GridComponent) {
        super(dataService,grid);
    }
    public ngOnChanges( c: any ) : void {
 
        console.log( "Base-Query CustomerGroup:", this.query);
        this.rebind();
    }

    
}